import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { useConsultationModal } from "@/hooks/use-consultation-modal";

export const SaintConsultationCta = ({
  onQuiz,
}: {
  onBook?: () => void;
  onQuiz: () => void;
}) => {
  const { openConsultation } = useConsultationModal();

  return (
    <section className="py-16 sm:py-20 bg-background">
      <div className="container-px mx-auto max-w-2xl px-4 text-center">
        <h2 className="font-headings text-2xl font-bold text-primary sm:text-3xl">
          Request a free consultation
        </h2>
        <p className="mt-3 text-sm text-foreground/80 leading-relaxed max-w-xl mx-auto">
          Your initial consultation is conducted over a convenient Zoom call. As
          your evaluation evolves, you have the option to meet our psychiatrist
          via Zoom web conference or in person at our clinic. (fMRI mapping and
          the 5-day treatment series are completed in person.) We respond within
          one business day. Front desk phones are answered from 9am.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={() => openConsultation("saint-consultation-cta")}
            size="lg"
            className="w-full bg-gradient-accent text-accent-foreground shadow-glow hover:opacity-90 sm:w-auto"
          >
            Request a Free Consultation
          </Button>
          <Button
            onClick={onQuiz}
            size="lg"
            variant="outline"
            className="w-full border-2 border-primary/20 text-primary hover:bg-muted sm:w-auto"
          >
            Get SAINT® Info &amp; Resources
          </Button>
        </div>
        <p className="mt-4 text-xs text-muted-foreground">
          Prefer to call?{" "}
          <a
            href="tel:9548279793"
            className="font-semibold text-accent underline underline-offset-2"
          >
            954-827-9793
          </a>
        </p>
      </div>
    </section>
  );
};
